(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-gallery"] && !Shopify.designMode) return;
  try {
    
  // Native <dialog> lightbox: clicking a gallery image opens a large version.
  (function () {
    document.querySelectorAll('[data-lightbox-dialog]').forEach(function (dialog) {
      var img = dialog.querySelector('[data-lightbox-img]');
      var section = dialog.closest('section');
      if (!section) return;

      section.querySelectorAll('[data-lightbox]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          img.src = btn.dataset.lightbox;
          dialog.showModal();
        });
      });

      // Close on backdrop click or on clicking the image itself.
      dialog.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('close', function () { img.src = ''; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-contact-form]').forEach(function (root) {
    var form = root.querySelector('.contact-form__form');
    if (!form) return;

    // Fire the Klaviyo event on submit, but never interfere with the native
    // submit: Shopify's invisible CAPTCHA hooks the submit event and a
    // programmatic form.submit() would skip it, causing "Invalid CAPTCHA token".
    form.addEventListener('submit', function () {
      if (typeof window.klaviyo === 'undefined') return;

      function value(name) {
        var field = form.querySelector('[name="contact[' + name + ']"]');
        return field ? field.value : '';
      }

      var email = value('email');

      try {
        if (email) {
          window.klaviyo.identify({ $email: email, $first_name: value('name') });
        }
        window.klaviyo.track('Submitted Contact Form', {
          name: value('name'),
          email: email,
          phone: value('phone'),
          subject: value('subject'),
          message: value('body'),
          source: 'Theme contact form'
        });
      } catch (err) {
        // Swallow tracking errors so the contact form still submits.
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
